import * as React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import { Box } from "@mui/material";

type CustomCheckBoxProps = {
  label: string;
  onChange: (checked: boolean) => void;
  checked: boolean;
};

// Label styles
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  ".MuiFormControlLabel-label": {
    color: "#797979",
    fontSize: "15px",
    fontWeight: 300,
    marginLeft:'10px',
  },
}));

// Custom unchecked icon (circle border)
const CustomUncheckedIcon = (
  <Box
    sx={{
      width: 18,
      height: 18,
      borderRadius: "50%",
      border: "2px solid #454545",
    }}
  />
);

// Custom checked icon (filled circle with check)
const CustomCheckedIcon = (
  <Box
    sx={{
      width: 18,
      height: 18,
      borderRadius: "50%",
      backgroundColor: "#6A0DAD",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CheckIcon sx={{ fontSize: 14, color: "common.white" }} />
  </Box>
);

// Custom Checkbox
const CustomCheckbox = styled(Checkbox)({
  padding: 0,
});

const CustomCheckBox: React.FC<CustomCheckBoxProps> = ({
  label,
  onChange,
  checked,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <FormGroup>
      <StyledFormControlLabel
      sx={{margin:'0 0 5px 0', padding:'0px',}}
        control={
          <CustomCheckbox
            checked={checked}
            onChange={handleChange}
            icon={CustomUncheckedIcon}
            checkedIcon={CustomCheckedIcon}
          />
        }
        label={label}
      />
    </FormGroup>
  );
};

export default CustomCheckBox;
